import type { AbilityBuilder, MongoQuery } from '@casl/ability'
import type { AppAbility } from '~/types/authorization.type'
import type { Report } from '~/types/report.type'
import type { User } from '~/types/user.type'
import { userRoles } from '../roles'

export function defineReportAbilities(abilityBuilder: AbilityBuilder<AppAbility>, user: User) {
  const { can } = abilityBuilder

  can('read', 'reports')
  can('read', 'reports-id-view')
  can('create', 'report')

  type ReportQuery = MongoQuery<Report<'withUser'>>

  can(['read', 'update', 'delete'], 'report', {
    userId: user.id,
  } as ReportQuery)

  const roles = userRoles(user)

  if (roles.administrator) {
    can(['read', 'update', 'delete', 'restore'], 'report')
  }
}
